export default function () {
  this.route('adminPlugins', { path: '/admin/plugins' }, function () {
    this.route('proxyviews-analytics', { path: '/proxyviews-analytics' });
  });
}
